module.exports = __webpack_public_path__ + "static/media/jose-pareja.cfc7be8c.png";